import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { take, takeWhile } from 'rxjs/operators';
import { ModalMessageComponent } from '../../../../shared/modais/modal-message/modal-message.component';
import { ModalEditVeiculoComponent } from '../modal-edit-veiculo/modal-edit-veiculo.component';
import { appSettings } from './../../../../../environments/app.setings';
import { FichaCadastro } from './../../ficha-cadastro';
import { FichaCadastroSharedService } from './../../shared/ficha-cadastro-shared.service';
import { PropostaSimulacao } from './../model/proposta/proposta-simulacao';
import { VeiculoSimulacao } from './../model/proposta/veiculo-simulacao';
import { SegurosService } from '../../../seguros.service';
import { CustomModalService } from '../../../../shared/modais/custom-modal/custom-modal.service';

@Component({
  selector: 'veiculo',
  templateUrl: './veiculo.component.html',
  styleUrls: ['./veiculo.component.scss'],
})
export class VeiculoComponent {
  @Input() veiculo: VeiculoSimulacao;
  @Input() fichaCadastro: FichaCadastro;
  @Input() proposta: PropostaSimulacao;
  @Input() numeroVeiculo: number;

  @Output() veiculoAlterar: EventEmitter<any> = new EventEmitter();

  @ViewChild('modalMessage', { static: true })
  modalMessage: ModalMessageComponent;

  constructor(
    private sharedService: FichaCadastroSharedService,
    private modalService: CustomModalService,
    private segurosService: SegurosService
  ) {}

  onClickAlterar() {
    this.fichaCadastro.setIdSimulacao(this.proposta.getIdSimulacao());
    this.openModalEditarVeiculo();
  }

  onClickRemover() {
    this.modalMessage
      .show('Deseja remover este veículo?', 'Sim', 'Não')
      .ok.pipe(take(1))
      .subscribe(() => {
        this.proposta.veiculos.splice(this.numeroVeiculo - 1, 1);
        this.clearCotacaoSeguro();
      });
  }

  get descricao() {
    return this.numeroVeiculo === 1 ? 'PRINCIPAL' : this.numeroVeiculo;
  }

  get isPesados(): boolean {
    return this.fichaCadastro.isPesados;
  }

  openModalEditarVeiculo() {
    const initialState = {
      mapForSave: true,
      veiculo: this.veiculo,
      veiculos: this.proposta.veiculos,
    };
    const modal = this.modalService.show(ModalEditVeiculoComponent, {
      ...appSettings.MODAL_PARAMS,
      initialState,
    });

    modal.content.onSave
      .pipe(takeWhile(() => modal.content.alive))
      .subscribe((veiculoAlterado: VeiculoSimulacao) => {
        this.proposta.veiculos[this.numeroVeiculo - 1] = veiculoAlterado;
        this.reEnviaParaSimulacao();
      });
  }

  private reEnviaParaSimulacao(): void {
    const payload = this.proposta.toPayload();
    this.fichaCadastro.setIdSimulacao(payload.id);
    this.fichaCadastro.replacePayload(payload);
    this.fichaCadastro.passoAlterarVeiculo();
    this.sharedService.simularProposta();
  }

  private clearCotacaoSeguro(): void {
    this.segurosService
      .clearCotacaoProposta(this.proposta.getId())
      .toPromise()
      .then((r) => {
        this.reEnviaParaSimulacao();
      });
  }

  public canRemoveVeiculo(): boolean {
    return (
      this.proposta.veiculos &&
      !!this.proposta.veiculos.length &&
      this.numeroVeiculo > 1
    );
  }
}
